import i18n from "shared/i18n";
import { withTranslations } from "shared/utils";

export const getMissingDataMessages = withTranslations(
  "Request",
  (callback) => {
    const descriptions = {
      DEFAULT: i18n.t("missing_profile_data.default", { ns: "Request" }),
      US: i18n.t("missing_profile_data.us", {
        ns: "Request",
      }),
      PL: i18n.t("missing_profile_data.pl", {
        ns: "Request",
      }),
      CA: i18n.t("missing_profile_data.ca", {
        ns: "Request",
      }),
      FI: i18n.t("missing_profile_data.fi", {
        ns: "Request",
      }),
      PH: i18n.t("missing_profile_data.ph", {
        ns: "Request",
      }),
      PR: i18n.t("missing_profile_data.pr", {
        ns: "Request",
      }),
    };

    callback(descriptions);
  }
);
